<template>
  <v-container fill-height d-block>
    <v-layout fill-height column justify-space-between>
      <div class="mt-5">
        <h1 class="pagetitle">Chage password</h1>
      </div>

      <div v-if="!succes">
        <input
          class="form-control mt-4"
          type="password"
          name="oldpassword"
          autocomplete="on"
          placeholder="Old password"
          v-model="form.oldPassword"
        >
        <input
          class="form-control mt-4"
          type="password"
          name="password"
          autocomplete="on"
          placeholder="New password"
          v-model="form.newPassword"
        >

        <div class="error">{{error}}</div>
      </div>

      <div v-if="succes">
        <h3>Password was updated!</h3>
      </div>


      <div>
        <v-btn block @click="submit">Change password</v-btn>
      </div>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      succes: false,
      error: '',
      form: {
        oldPassword: '',
        newPassword: '',
      }
    }
  },
  methods: {
    ...mapActions('auth', ['changePassword']),

    submit() {
      this.changePassword(this.form)
        .then(() => this.succes = true)
        .catch(({ message }) => this.error = message)
    }
  }
}
</script>

<style lang="scss" scoped>
.pagetitle {
  color: #65ADF8
}

.error {
  padding: 15px 0;
  min-height: 60px;
  color: rgb(255, 98, 98);
}
</style>